const n = {
  3: [2, 4, 7],
  4: [4, 8, 14],
  5: [8, 16, 30],
  6: [16, 32, 100],
  7: [32, 64, 200],
  8: [64, 128, 300]
}
export const customMapUrl = (x, y, z, baseUrl) => {
  if (!n[z]) { return '' }
  var r = n[z][1]
  var o = x - r + 1
  var i = y - r + 1
  var p = z < 5 ? 40 : 100
  var wh = 9600 / (200 / p) / n[z][0]
  var nx = wh * (o - 1)
  var ny = wh * (i - 1)
  if ((nx += (z < 5 ? 1920 : 4800)) < 0 || ny < 0 || (z <= 4 && nx >= 4800) || (z === 5 && (nx < 0 || ny < 0)) || (z >= 6 && nx < 300) || (z >= 5 && ny >= 9000) || (z > 4 && nx >= 12e3)) {
    return ''
  } else {
    return baseUrl + '?x-oss-process=image/resize,p_' + p + '/crop,x_' + nx + ',y_' + ny + ',w_' + wh + ',h_' + wh
  }
}

export const wrapViewList = [
  [{ name: '全地图', view: [-60, 0], zoom: 3.5 },
    { name: '中央海拉鲁', view: [-66.84627334160784, 20.738223916923214], zoom: 5 },
    { name: '海布拉地区', view: [-35.96022296929668, -38.40820312500001], zoom: 5 },
    { name: '奥尔汀地区', view: [-37.890233584521106, 57.34342945471512], zoom: 5 },
    { name: '阿卡莱地区', view: [-27.122327887156565, 98.73403537690423], zoom: 5 },
    { name: '拉聂尔地区', view: [-69.20940390181204, 85.078125], zoom: 5 },
    { name: '哈特尔地区', view: [-76.4311367001563, 75.4906620812605], zoom: 5 },
    { name: '费罗尼地区', view: [-81.20813892964775, 49.43847656250001], zoom: 5 },
    { name: '格鲁德地区', view: [-80.30457782808982, -49.11619208388846], zoom: 5 }],
  [
    { name: '全地图', view: [-60, 0], zoom: 3.5 },
    { name: '中央海拉鲁空域', view: [-64.92354174306496, 20.654296875000004], zoom: 5 },
    { name: '海布拉空域', view: [-37.23032838760386, -38.23242187500001], zoom: 5 },
    { name: '奥尔汀空域', view: [-40.713955826286046, 58.09570312500001], zoom: 5 },
    { name: '阿卡莱空域', view: [-31.952162238024975, 102.12890625000001], zoom: 5 },
    { name: '拉聂尔空域', view: [-68.8159271333607, 81.65039062500001], zoom: 5 },
    { name: '哈特尔空域', view: [-76.63376814571944, 74.9313295687985], zoom: 5 },
    { name: '费罗尼空域', view: [-79.77336504333218, 44.47265625000001], zoom: 5 },
    { name: '格鲁德空域', view: [-79.88776213754625, -47.4381945465024], zoom: 5 }
  ],
  [
    { name: '全地图', view: [-60, 0], zoom: 3.5 },
    { name: '海布拉废矿', view: [-39.77476948529546, -39.90234375000001], zoom: 5 },
    { name: '奥尔汀废矿', view: [-41.11246878918086, 56.42578125000001], zoom: 5 },
    { name: '一始废矿', view: [-45.583289756006316, 100.01953125000001], zoom: 5 },
    { name: '拉聂尔废矿', view: [-56.365250136856076, 88.94531250000001], zoom: 5 },
    { name: '卡卡利科废矿', view: [-73.72659470212253, 63.10546875000001], zoom: 5 },
    { name: '中央大废矿', view: [-75.49715731893083, 4.042968750000001], zoom: 5 },
    { name: '哈特诺废矿', view: [-79.49665183507658, 95.80078125000001], zoom: 5 },
    { name: '沃托里废矿', view: [-82.14245132495608, 82.08984375000001], zoom: 5 },
    { name: '格鲁德废矿', view: [-79.6240562918881, -47.81250000000001], zoom: 5 }
  ]
]
